import type { HqlValue } from '@rock/hql';
import { countBy } from 'lodash';

/**
 * Covered units by type ("2 × mini-split, heat-pump"), or "the whole home" when there are none. An id
 * `units` lacks shows as itself.
 */
export function describeCoveredUnits(
    coveredIds: readonly string[],
    units: readonly { id: string; typeId: string }[],
): string {
    if (coveredIds.length === 0) return 'the whole home';
    const typeOf = new Map(units.map((unit) => [unit.id, unit.typeId]));
    const counts = countBy(coveredIds, (id) => typeOf.get(id) ?? id);
    return Object.entries(counts)
        .map(([typeId, count]) => (count > 1 ? `${count} × ${typeId}` : typeId))
        .join(', ');
}

export function formatUnitFields(fields: Record<string, HqlValue>): string {
    return (
        Object.entries(fields)
            .map(([key, value]) => `${key}: ${formatHqlValue(value)}`)
            .join(' · ') || 'no fields'
    );
}

export function formatHqlValue(value: HqlValue): string {
    return Array.isArray(value) ? `[${value.join(', ')}]` : `${value}`;
}
